import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import store from 'store';
import { useHistory } from 'react-router-dom';

import './header.style.css';
// import avatar from './avatar.png';
// import avatart2 from './avatar_2.svg'
import logo from './Intelli-Logo-crop-2-1.svg';
import avatarTho from './avatar_4.svg'




const Header = () => {
    const history = useHistory();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = (history) => () => {
        store.remove('loggedIn');
        setAnchorEl(null);
        history.push('/signin');
      };

      const handleAccount = (history) => () => {
        
        setAnchorEl(null);
        history.push('/account');
      };

    return (
        <div className="section-header">
            <div className="header">
                <h1 className="name-app-header">NRW Management</h1>
                <img src={logo} alt="" className="logo-center" width="32" />
                <div className="user-info-header">
                    <p className="user-name">Intelli Admin</p>
                    <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                        <img src={avatarTho} width="32" alt="" />
                    </Button>
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        {/* <MenuItem onClick={handleClose}>Profile</MenuItem> */}
                        <MenuItem onClick={handleAccount(history)}>My account</MenuItem>
                        <MenuItem onClick={handleLogout(history)}>Sign out</MenuItem>
                    </Menu>

                </div>
            </div>
        </div>
    )

}

export default Header;
